<p-toast></p-toast>
<p-confirmDialog
    [style]="{ minWidth: '40vw' }"
    position="top"
    [baseZIndex]="10000"
    rejectButtonStyleClass="p-button-outlined"
></p-confirmDialog>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <h5>Informe de llamadas</h5>
            <hr />
            <form
                *ngIf="formGroup"
                [formGroup]="formGroup"
                (ngSubmit)="ejecutar()"
            >
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_desde">Fecha Desde</label>
                        <p-calendar
                            id="fecha_desde"
                            formControlName="fecha_desde"
                            dateFormat="dd/mm/yy"
                            showTime="true"
                            hourFormat="24"
                            (onFocus)="detenerIntervalo()"
                            (onBlur)="reaunudarIntervalo()"
                        ></p-calendar>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_hasta">Fecha Hasta</label>
                        <p-calendar
                            id="fecha_hasta"
                            formControlName="fecha_hasta"
                            dateFormat="dd/mm/yy"
                            showTime="true"
                            hourFormat="24"
                            (onFocus)="detenerIntervalo()"
                            (onBlur)="reaunudarIntervalo()"
                        ></p-calendar>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="recuperadores">Usuarios:</label>
                        <p-multiSelect
                            [options]="recuperadores"
                            optionLabel="cnam"
                            optionValue="cnam"
                            display="cnam"
                            formControlName="recuperadores"
                            placeholder="Seleccione los usuarios"
                            [showToggleAll]="true"
                            display="chip"
                            (onFocus)="detenerIntervalo()"
                            (onPanelHide)="reaunudarIntervalo()"
                        ></p-multiSelect>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="estados">Estado:</label>
                        <p-multiSelect
                            [options]="estadosLlamada"
                            optionLabel="nombre"
                            optionValue="valor"
                            display="nombre"
                            formControlName="estado"
                            placeholder="Seleccione el estado"
                            [showToggleAll]="true"
                            display="chip"
                            (onFocus)="detenerIntervalo()"
                            (onPanelHide)="reaunudarIntervalo()"
                        ></p-multiSelect>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            type="submit"
                            label="Ejecutar"
                            icon="pi pi-check"
                            class="p-button-info mr-2"
                            pTooltip="Ejecutar"
                        ></button>
                    </div>
                    <ng-container *ngIf="items?.length">
                        <div class="col-12 md:col-2">
                            <p-splitButton
                                label="Imprimir"
                                [model]="opcionesImpresion"
                                icon="pi pi-print"
                                styleClass="mi-splitbutton"
                            ></p-splitButton>
                        </div>
                        <div class="col-12 md:col-2">
                            <button
                                pButton
                                pRipple
                                class="p-button-success"
                                label="Descargar"
                                icon="pi pi-file-excel"
                                (click)="descargarExcel()"
                            ></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button
                                pButton
                                pRipple
                                class="p-button-info"
                                label="Pantalla Completa"
                                icon="pi pi-desktop"
                                (click)="mostrarGraficoCompleto(true)"
                            ></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button
                                pButton
                                pRipple
                                class="p-button-warning"
                                label="Configurar Llamadas"
                                icon="pi pi-cog"
                                (click)="mostrarConfigurarLlamadas(true)"
                            ></button>
                        </div>
                    </ng-container>
                </div>
            </form>
            <hr />
            <div
                class="div-grafico"
                *ngIf="mostrarGrafico"
                [ngStyle]="
                    pantallaCompletaGrafico
                        ? {
                              width: '100vw',
                              height: '100vh',
                              position: 'fixed',
                              top: '0',
                              left: '0',
                              'z-index': '9999',
                              'background-color': 'white'
                          }
                        : { width: 'auto', height: 'auto' }
                "
            >
                <div class="col-12" *ngIf="pantallaCompletaGrafico">
                    <button
                        pButton
                        pRipple
                        class="p-button-info"
                        label="Pantalla Normal"
                        icon="pi pi-arrow-left"
                        (click)="mostrarGraficoCompleto(false)"
                    ></button>
                </div>
                <div
                    id="chart-container"
                    style="background-color: white; margin: auto"
                    class="col-12"
                    [ngStyle]="
                        pantallaCompletaGrafico
                            ? { height: '70%' }
                            : { height: '500px' }
                    "
                ></div>
                <ng-container *ngIf="resumenRecuperadores?.length > 0">
                    <p-carousel
                        [value]="resumenRecuperadores"
                        [numVisible]="3"
                        [numScroll]="1"
                        [circular]="true"
                        [responsiveOptions]="responsiveOptions"
                        autoplayInterval="10000"
                    >
                        <ng-template let-resumen pTemplate="item">
                            <div class="div-resumen-recuperador">
                                <div
                                    class="resumen-recuperador"
                                    style="margin: 5px"
                                >
                                    <div class="div-icono-recuperador col-12">
                                        <i
                                            class="pi pi-user"
                                            style="font-size: 2rem; margin: 5px"
                                        ></i>
                                        <h2 class="nombre-recuperador">
                                            {{ resumen.usuario }}
                                        </h2>
                                    </div>
                                    <div class="col-12 div-info-recuperador">
                                        Promedio de llamada:
                                        {{
                                            convertirSegundos(
                                                resumen.promedioDuracion
                                            )
                                        }}
                                        <br />
                                        Total de llamadas:
                                        {{ resumen.totalLlamadas }}
                                        <br />
                                        Tiempo de llamada:
                                        {{
                                            convertirSegundos(
                                                resumen.totalTiempoLlamada
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-carousel>
                </ng-container>
            </div>
            <hr />
            <p-table
                styleClass="p-datatable-sm p-datatable-gridlines"
                [value]="items"
                [loading]="loading"
                dataKey="usuario"
                responsiveLayout="scroll"
                rowHover="true"
                [showCurrentPageReport]="true"
                [paginator]="true"
                [rows]="20"
                currentPageReportTemplate="Mostrando {first} a {last} de {{
                    items.length
                }} entradas"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th
                            class="cabecera align-center"
                            style="max-width: 2rem"
                        ></th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="usuario"
                        >
                            Usuario<p-sortIcon field="usuario"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="totalLlamadas"
                        >
                            Total de Llamadas<p-sortIcon
                                field="totalLlamadas"
                            ></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="llamadasEfectivas"
                        >
                            Llamadas Efectivas<p-sortIcon
                                field="llamadasEfectivas"
                            ></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="llamadasCortas"
                        >
                            Llamadas Cortas<p-sortIcon
                                field="llamadasCortas"
                            ></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="promedioDuracion"
                        >
                            Llamadas Repetidas<p-sortIcon
                                field="llamadasRepetidas"
                            ></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="promedioDuracion"
                        >
                            Promedio de Llamadas<p-sortIcon
                                field="promedioDuracion"
                            ></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="totalTiempoLlamada"
                        >
                            Tiempo en Llamada<p-sortIcon
                                field="totalTiempoLlamada"
                            ></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr class="p-0 m-0">
                        <td style="max-width: 2rem" class="p-0 m-0">
                            <button
                                type="button"
                                pButton
                                pRipple
                                [pRowToggler]="item"
                                class="p-button-sm p-button-text p-button-rounded"
                                [icon]="
                                    expanded
                                        ? 'pi pi-chevron-down'
                                        : 'pi pi-chevron-right'
                                "
                            ></button>
                        </td>
                        <td class="align-center">
                            <b>{{ item.usuario }}</b>
                        </td>
                        <td class="align-center">{{ item.totalLlamadas }}</td>
                        <td class="align-center">
                            {{ item.llamadasEfectivas }}
                        </td>
                        <td class="align-center">{{ item.llamadasCortas }}</td>
                        <td class="align-center">
                            {{ item.llamadasRepetidas }}
                        </td>
                        <td class="align-center">
                            {{ convertirSegundos(item.promedioDuracion) }}
                        </td>
                        <td class="align-center">
                            {{ convertirSegundos(item.totalTiempoLlamada) }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-item>
                    <tr>
                        <td colspan="12" class="pt-0">
                            <div class="pl-3 pr-3 pb-3">
                                <p-table
                                    #tabla
                                    [value]="item.detalleLlamada"
                                    styleClass="p-datatable-sm p-datatable-gridlines"
                                    dataKey="id"
                                    responsiveLayout="scroll"
                                    [showCurrentPageReport]="true"
                                    [paginator]="true"
                                    [rows]="15"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {{
                                        item.detalleLlamada.length
                                    }} entradas"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th
                                                class="cabecera-detalle align-center"
                                                pSortableColumn="fecha_llamada"
                                            >
                                                Fecha de Llamada<p-sortIcon
                                                    field="fecha_llamada"
                                                ></p-sortIcon>
                                            </th>
                                            <th
                                                class="cabecera-detalle align-center"
                                                pSortableColumn="destino"
                                            >
                                                Destino<p-sortIcon
                                                    field="destino"
                                                ></p-sortIcon>
                                            </th>
                                            <th
                                                class="cabecera-detalle align-center"
                                                pSortableColumn="estado"
                                            >
                                                Estado<p-sortIcon
                                                    field="estado"
                                                ></p-sortIcon>
                                            </th>
                                            <th
                                                class="cabecera-detalle align-center"
                                                pSortableColumn="duracion"
                                            >
                                                Duracion<p-sortIcon
                                                    field="duracion"
                                                ></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-detalle>
                                        <tr>
                                            <td class="align-center">
                                                {{
                                                    detalle.fecha_llamada
                                                        | date
                                                            : "dd/MM/yyyy HH:mm:ss"
                                                }}
                                            </td>
                                            <td class="align-center">
                                                {{ detalle.destino }}
                                            </td>
                                            <td class="align-center">
                                                {{
                                                    obtenerEstado(
                                                        detalle.estado
                                                    )
                                                }}
                                            </td>
                                            <td class="align-center">
                                                {{
                                                    convertirSegundos(
                                                        detalle.duracion
                                                    )
                                                }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="cabecera-detalle" colspan="2">TOTALES</td>
                        <td class="cabecera-detalle align-center">
                            <b>{{ totalLlamadas }}</b>
                        </td>
                        <td class="cabecera-detalle align-center">
                            <b>{{ totalLlamadasEfectivas }}</b>
                        </td>
                        <td class="cabecera-detalle align-center">
                            <b>{{ totalLlamadasCortas }}</b>
                        </td>
                        <td class="cabecera-detalle align-center">
                            <b>{{ totalLlamadasRepetidas }}</b>
                        </td>
                        <td class="cabecera-detalle align-center">
                            <b>{{ convertirSegundos(totalPromedio) }}</b>
                        </td>
                        <td class="cabecera-detalle align-center">
                            <b>{{
                                convertirSegundos(totalDuracionLlamadas)
                            }}</b>
                        </td>
                        <td class="cabecera-detalle"></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<app-on-lista
    [show]="showOnLista"
    [title]="tituloOnLista"
    [columns]="columnasOnLista"
    [service]="serviceOnLista"
    [recordName]="recordNameOnLista"
    [filters]="filters"
    (close)="cerrarOnLista($event)"
>
</app-on-lista>

<!-- Modulo Dialog -->
<p-dialog
    [(visible)]="configurarLlamadas"
    position="center"
    modal="true"
    header="Configurar Llamadas"
    [breakpoints]="{ '960px': '75vw', '400px': '95vw' }"
    [style]="{ width: '50vw' }"
    [closeOnEscape]="true"
>
    <div class="grid">
        <div class="col-12">
            <form *ngIf="fgConfigLlamadas" [formGroup]="fgConfigLlamadas">
                <div class="flex flex-column">
                    <div class="field col-12 md:col-12">
                        <label htmlFor="llamadas_cortas"
                            >Condicion de llamadas cortas:
                        </label>
                        <br />
                        <span>Llamadas inferiores a </span>
                        <p-inputNumber
                            [inputStyle]="{ width: '4rem' }"
                            placeholder="Ingrese los segundos de llamada"
                            formControlName="llamadas_cortas"
                        ></p-inputNumber>
                        <span> segundos</span>
                    </div>
                    <div class="field col-12 md:col-12">
                        <label htmlFor="llamadas_repetidas"
                            >Condicion de llamadas repetidas:
                        </label>
                        <br />
                        <span> Cantidad de llamadas al mismo numero: </span>
                        <p-inputNumber
                            [inputStyle]="{ width: '4rem' }"
                            placeholder="Ingrese la cantidad de llamadas"
                            formControlName="llamadas_repetidas"
                        ></p-inputNumber>
                    </div>
                </div>
                <div class="flex flex-row justify-content-space-between">
                    <button
                        pButton
                        pRipple
                        type="button"
                        class="p-button-danger"
                        label="Cancelar"
                        icon="pi pi-times"
                        (click)="mostrarConfigurarLlamadas(false)"
                    ></button>
                    <button
                        pButton
                        pRipple
                        type="button"
                        class="p-button-success"
                        label="Aplicar configuracion"
                        icon="pi pi-check"
                        (click)="aplicarConfiguracion()"
                    ></button>
                </div>
            </form>
        </div>
    </div>
</p-dialog>
